<template>
  <div class="text-center" style="margin-top: 5vh;">
    <img src="@/resources/images/404_not_found.svg" alt="empty_img" style="max-width: 95%; max-height: 300px; height: auto; width: auto;" />

    <h4 class="title">The page you are looking for doesn't exist!</h4>
    <p class="description text-medium">You may have mistyped the address or the page may have moved.</p>
  </div>
</template>
